import StvJaNeinUnbekannt from "../../../../../../consumer/form/dto/StvJaNeinUnbekannt";
import useWizardFormCtx from "../../../ctx-provider/useWizardFormCtx";
import TextInputFieldMultiline from "../../../../../cmp/input/TextInputFieldMultiline";
import StringUtil from "../../../../../../app/util/StringUtil";
import FormBo from "../../FormBo";
import { useState } from "react";
import useInputSubmitValidator, { generateValidatorId } from "../../../../../../form/input/useInputSubmitValidator";
import VorschFreitextValidator from "./VorschFreitextValidator";
import GtmFormularfeldId from "../../../../../../gtm/types/GtmFormularfeldId";

export const exportVorschadenFreitext = (bo: FormBo) => bo.vorschaden === StvJaNeinUnbekannt.JA ? StringUtil.trim(bo.vorschadenFreitext) : undefined;

const VALIDATOR_ID = generateValidatorId("Antrag-VorschadenFreitext");

const VorschFreitext: React.FC = () => {
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const [vorschadenFreitext, setVorschadenFreitext] = useState(wizardFormBo.antrag.vorschadenFreitext);

    // *** Validator wird initialisiert
    const { validationState, fireFieldValidation } = useInputSubmitValidator(VALIDATOR_ID, new VorschFreitextValidator(vorschadenFreitext));

    const updateValidationState = (value?: string) => {
        fireFieldValidation(new VorschFreitextValidator(value));
    }

    // ****************************
    // events
    // ****************************    
    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        updateValidationState(value);

        wizardFormBo.antrag.vorschadenFreitext = value;
        fireWizardFormBo(wizardFormBo);
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // Zeilenumbrueche werden entfernt
        setVorschadenFreitext(StringUtil.replaceLineBreak(event.target.value));
    }

    return (
        <TextInputFieldMultiline
            id="vorschaden-freitext"
            idGtm={GtmFormularfeldId.vorschadenFreitext}
            label="Beschreibung Vorschäden"
            value={vorschadenFreitext}
            error={validationState.error}
            required={true}
            onBlur={handleOnBlur}
            onChange={handleOnChange}
            maxLength={VorschFreitextValidator.MAX_LENGTH}
            helperText={validationState.message} />
    );
}

export default VorschFreitext;